import api from "@/api";
import deepClone from "@/utils/deep-clone";

const state = {
    status: {},
    list: [],
};

const getters = {
    status(state) {
        return state.status;
    },
    list(state) {
        return deepClone(state.list || []);
    },
};

const actions = {
    getStatus({ commit }) {
        return api.get(`/api/jira/status`).then(res => {
            const status = res.data || {};
            commit("updateStatus", status);
        });
    },
    search({ commit }, { payload: { query } }) {
        return api.post(`/api/jira/issueLookup`, { query }).then(res => {
            const list = res.data || [];
            commit("updateList", list);
        });
    },
    reset({ commit }) {
        commit("updateList", []);
    },
};

const mutations = {
    updateStatus(state, status) {
        state.status = { ...status };
    },
    updateList(state, list) {
        state.list = [...list];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
